import React, { FC, lazy } from 'react'

import { Route, Routes, useLocation } from 'react-router-dom'

import { wrapSuspenseComponent, wrapSuspenseScreen } from '@components'
import { lazy as loadable } from '@loadable/component'

const EventAttendConfirmationModal = wrapSuspenseComponent(
  loadable(
    () =>
      import(
        '@modals/EventAttendConfirmationModal/EventAttendConfirmationModal'
      )
  )
)
const EventEditNavigator = wrapSuspenseScreen(
  loadable(() => import('./EventEditNavigator'))
)
const EventScreen = wrapSuspenseScreen(
  loadable(() => import('@screens/EventScreen/EventScreen'))
)

export const EventNavigator: FC = () => {
  const location = useLocation()

  const locationState = location.state as { backgroundLocation?: Location }

  return (
    <Routes location={locationState?.backgroundLocation || location}>
      <Route index element={<EventScreen />} />

      <Route path='attend' element={<EventAttendConfirmationModal />} />
      <Route path='settings/*' element={<EventEditNavigator />} />
    </Routes>
  )
}

export default EventNavigator
